var map = {
	"./banner_home.vue": 1360,
	"./cards.vue": 1361,
	"./cart.vue": 1362,
	"./category.vue": 1363,
	"./checkout.vue": 1364,
	"./cmsPreview.vue": 1365,
	"./coupons.vue": 1366,
	"./dshop.vue": 1367,
	"./index.vue": 1368,
	"./order_details.vue": 1369,
	"./order_list.vue": 1370,
	"./payment_result.vue": 1371,
	"./pending_payment.vue": 1372,
	"./productDetails.vue": 1373,
	"./receipt.vue": 1374,
	"./search.vue": 1375,
	"./similar.vue": 1376,
	"./store_locator.vue": 1359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 886;